import {
  ColorFieldProps,
  ColorSelectOption,
  DynamicField,
  DynamicForm,
  FieldVariant,
  SelectFieldProps,
  SelectOption,
  TextFieldProps,
} from '../../../../components/form-builder/form-builder.types';
import { RefParamRepository } from '../../../../store/ref-param-state/ref-param-state.repository';
import { RefType } from '@/types';

interface getRefParamsFormObjectProps {
  store: RefParamRepository;
  refTypes?: RefType[];
}

export const getRefParamsFormObject = ({ store, refTypes }: getRefParamsFormObjectProps): DynamicForm => {
  const codeField: DynamicField<TextFieldProps> = {
    label: 'settings.refParams.form.code',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'code'),
    props: {
      value: store.getNestedObservable<string>('dto', 'code'),
      onChange: (value: string) => {
        store.setNested('dto', 'code', value);
        store.setNested('errors', 'code', '');
      },
    },
  };
  const descriptionField: DynamicField<TextFieldProps> = {
    label: 'settings.refParams.form.description',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'description'),
    props: {
      value: store.getNestedObservable<string>('dto', 'description'),
      onChange: (value: string) => {
        store.setNested('dto', 'description', value);
        store.setNested('errors', 'description', '');
      },
    },
  };

  const typeField: DynamicField<SelectFieldProps> = {
    label: 'settings.refParams.form.refType.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'refTypeId'),
    props: {
      placeholder: 'settings.refParams.form.refType.palceholder',
      options: refTypes?.map(refType => {
        return { name: refType.description, code: refType.id };
      }),
      value: store.getObservable('refTypeIdSelected'),
      onSelectChange: (value: SelectOption) => {
        store.setNested('dto', 'refTypeId', value.code);
        store.set('refTypeIdSelected', value);
        store.setNested('errors', 'refTypeId', '');
      },
    },
  };

  const codeColorField: DynamicField<ColorFieldProps> = {
    label: 'settings.refParams.form.codeColor',
    variant: FieldVariant.COLOR,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'codeColor'),
    props: {
      value: store.getNestedObservable<string>('dto', 'codeColor'),
      onChange: (color: ColorSelectOption) => {
        store.set('codeColorColorSelected', color);
        store.setNested('dto', 'codeColor', color.value);
        store.clearError('errors', 'codeColor');
      },
    },
  };

  return {
    title: 'Paramètres de référence',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [codeField],
          },
          {
            fields: [descriptionField],
          },
          {
            fields: [typeField],
          },
          {
            fields: [codeColorField],
          },
        ],
      },
    ],
  };
};
